class AnchorScroller {
    constructor(anchorSelector, targetSelector, offset = 0) {
        this.anchor = document.querySelector(anchorSelector);
        this.target = document.querySelector(targetSelector);
        this.offset = offset;

        if (this.anchor && this.target) {
            this.init();
        }
    }

    init() {
        this.anchor.addEventListener('click', (e) => {
            e.preventDefault();
            this.scrollToTarget();
        });
    }

    scrollToTarget() {
        const targetPosition = this.target.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({
            top: targetPosition - this.offset,
            behavior: 'smooth'
        });
    }
}

export default AnchorScroller;